import React from "react";
import "./Skills.css";

const Skills = ({ img }) => {
    return (
        <div>
            <h3>Skills</h3>
            <div id="skills">
                    <p className='skillBox'>Java</p>
                    <p className='skillBox'>C++</p>
                    <p className='skillBox'>Dart</p>
                    <p className='skillBox'>Kotlin</p>
                    <p className='skillBox'>Python</p>
                    <p className='skillBox'>JavaScript</p>
                    <p className='skillBox'>HTML</p>
                    <p className='skillBox'>CSS</p>
                    <p className='skillBox'>Flutter</p>
                    <p className='skillBox'>Android</p>
                    <p className='skillBox'>Mockito</p>
                    <p className='skillBox'>Unity</p>
                    <p className='skillBox'>GCP</p>
                    <p className='skillBox'>AWS</p>
                    <p className='skillBox'>Firebase</p>
                    <p className='skillBox'>Git</p>
                    <p className='skillBox'>Figma</p>
                    <p className='skillBox'>React</p>
                    <p className='skillBox'>Flask</p>
                    <p className='skillBox'>MongoDB</p>
                    <p className='skillBox'>Kali Linux</p>
                    <p className='skillBox'>WearOS</p>
                </div>

            <div id="copyright">
                © Nitin Ramadoss 2023
            </div>
        </div>
    );
}

export default Skills;